import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../ui/dialog';
import { Card } from '../ui/card';
import { GraduationCap, Award, MapPin } from 'lucide-react';
import { ScrollArea } from '../ui/scroll-area';

const EducationModal = ({ isOpen, onClose, education }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-slate-950 border-slate-800 text-white max-w-4xl max-h-[80vh]">
        <DialogHeader>
          <DialogTitle className="text-3xl font-bold">Education</DialogTitle>
          <DialogDescription className="text-slate-400">
            Academic excellence with a focus on finance and technology
          </DialogDescription>
        </DialogHeader>
        
        <ScrollArea className="h-[60vh] pr-4">
          <div className="space-y-6">
            {education.map((edu) => (
              <Card key={edu.id} className="bg-slate-900 border-slate-800 p-8">
                <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-6">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2">
                      <GraduationCap className="text-blue-500" size={28} />
                      <h3 className="text-2xl font-bold text-white">{edu.degree}</h3>
                    </div>
                    <p className="text-xl text-blue-400 font-medium mb-2">{edu.institution}</p>
                    {edu.concentration && (
                      <p className="text-slate-400">Concentration: <span className="text-slate-300">{edu.concentration}</span></p>
                    )}
                    {edu.major && (
                      <p className="text-slate-400">Major: <span className="text-slate-300">{edu.major}</span></p>
                    )}
                    {edu.minor && (
                      <p className="text-slate-400">Minor: <span className="text-slate-300">{edu.minor}</span></p>
                    )}
                    <div className="flex items-center gap-2 mt-2 text-slate-400">
                      <MapPin size={16} />
                      <span>{edu.location}</span>
                    </div>
                  </div>
                  
                  <div className="bg-blue-950 px-6 py-3 rounded-lg border border-blue-800">
                    <p className="text-sm text-slate-400 mb-1">GPA</p>
                    <p className="text-3xl font-bold text-blue-400">{edu.gpa}</p>
                  </div>
                </div>
                
                {edu.achievements && edu.achievements.length > 0 && (
                  <div className="mt-6 pt-6 border-t border-slate-800">
                    <div className="flex items-center gap-2 mb-3">
                      <Award className="text-yellow-500" size={20} />
                      <h4 className="text-lg font-semibold text-white">Achievements</h4>
                    </div>
                    <ul className="space-y-2">
                      {edu.achievements.map((achievement, idx) => (
                        <li key={idx} className="text-slate-300 flex items-start gap-2">
                          <span className="text-yellow-500 mt-1">•</span>
                          <span>{achievement}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </Card>
            ))}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default EducationModal;
